import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpIcon from "@mui/icons-material/HelpOutlineOutlined";
import { Grid, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

export default function UpdateInspectionTitlesInfoCard() {
  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <HelpIcon color="primary" />
          <Typography style={{ paddingLeft: ".25em" }}>
            How to use: Update Inspection Titles
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ textAlign: "left" }}>
            <p>
              Please ensure that the customer is aware of the risks. This change
              is not reversible once applied.
            </p>
            <p>
              Update Inspection Titles will retrieve a template&apos;s current
              Inspection Title Rule and apply it to inspections. You can target
              inspections in two ways:
            </p>
            <p>
              <b>Option 1:</b> Provide a list of specific inspection IDs
              <br />
              <b>Option 2:</b> Provide a template ID and inspection organisation
              ID to update all inspections from that template in that
              organisation
            </p>
            <p>
              <b>Warning: </b>
              In the event that an inspection{" "}
              <b> does not include any of the question field </b> used in the
              current inspection title format,
              <b> template title</b> will be used instead.
            </p>
            <ul>
              <li>
                <b>Inspection IDs</b> - List of inspection IDs, one per row
                (mutually exclusive with Template ID + Org ID)
              </li>
              <li>
                <b>Template ID</b> - The template ID to target inspections from
                (requires Inspection Org ID)
              </li>
              <li>
                <b>Inspection Org ID</b> - The organisation ID containing the
                inspections (requires Template ID)
              </li>
              <li>
                <b>Customer Request</b> - Link to the customer interaction
                requesting this be run
              </li>
              <li>
                <b>Region</b> - The region in which the customer&apos;s data is
                stored
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
